import { heroStats, tickerItems } from "@/mocks/chigua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      {/* 大主视觉压顶背景 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=expansive%20warm%20editorial%203D%20illustration%20with%20a%20central%20glowing%20golden%20megaphone%20casting%20wide%20light%20rays%20and%20concentric%20news%20wave%20rings%2C%20floating%20glossy%20notification%20cards%20and%20small%20star%20sparkles%20drifting%20in%20the%20air%2C%20layered%20cream%20background%20blending%20into%20soft%20vermilion%20orange%20top%20glow%20and%20fresh%20watermelon%20green%20lower%20glow%2C%20dynamic%20high%20energy%20atmosphere%2C%20soft%20cinematic%20studio%20lighting%2C%20ultra%20high%20detail%2C%20premium%20quality%2C%20no%20text%2C%20no%20watermark&width=1800&height=1000&seq=hero-chigua-main&orientation=landscape"
          alt="吃瓜官网官方公告与消息动态大图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-background-950/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto flex min-h-[92vh] w-full max-w-7xl flex-col justify-center px-4 pb-14 pt-28 md:px-6 md:pt-32">
        <div className="mx-auto w-full max-w-4xl text-center">
          <span className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
            <i className="ri-megaphone-line text-sm text-secondary-300"></i>
            官方消息 一站尽览 · 每日更新
          </span>

          <h1
            className="font-heading animate-fade-up mt-6 text-3xl font-black leading-tight text-background-50 sm:text-4xl md:text-[56px] md:leading-[1.12]"
            style={{ animationDelay: '80ms' }}
          >
            吃瓜官网官方公告与
            <br className="hidden sm:block" />
            消息动态<span className="text-secondary-300">权威发布中心</span>
          </h1>

          <p
            className="animate-fade-up mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg"
            style={{ animationDelay: '160ms' }}
          >
            聚合最新吃瓜官网公告、正式声明与官方通知,第一时间掌握平台动态,不再错过任何一条重要官方消息。
          </p>

          <div
            className="animate-fade-up mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row"
            style={{ animationDelay: '240ms' }}
          >
            <a
              href="#announcements"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 shadow-none transition-all hover:-translate-y-0.5 hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-folder-open-line text-base"></i>
              查看官方公告
            </a>
            <a
              href="#statements"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-all hover:-translate-y-0.5 hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-verified-badge-line text-base"></i>
              了解平台声明
            </a>
          </div>
        </div>

        {/* 数据区 */}
        <div
          className="animate-fade-up mx-auto mt-12 w-full max-w-4xl"
          style={{ animationDelay: '320ms' }}
        >
          <div className="grid grid-cols-2 gap-3 rounded-2xl border border-background-50/15 bg-background-50/10 p-4 backdrop-blur-md sm:grid-cols-4 md:gap-4 md:p-5">
            {heroStats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="font-label text-2xl font-bold text-background-50 md:text-[32px]">
                  {s.value}
                  <span className="ml-0.5 text-sm font-medium text-secondary-300">{s.unit}</span>
                </div>
                <div className="mt-1 text-xs text-background-100/80 md:text-sm">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-background-100/75">
            {['官方认证标识', '信息可溯源', '多端同步订阅', '内容真实可查'].map((t) => (
              <span key={t} className="inline-flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-sm text-accent-300"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 底部滚动短讯 */}
      <div className="relative border-t border-background-50/15 bg-background-950/50 backdrop-blur">
        <div className="flex items-center">
          <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-600 px-4 py-3 text-sm font-semibold text-background-50 md:px-6">
            <i className="ri-flashlight-fill text-base"></i>
            最新官方动态
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex w-max items-center gap-10 whitespace-nowrap py-3 pr-10 text-sm text-background-100/90">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="inline-flex items-center gap-2">
                  <i className="ri-arrow-right-up-line text-accent-300"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}